(() => {
  if (window.__ssProductPageEnhancementsLoaded) return;
  window.__ssProductPageEnhancementsLoaded = true;

  const installVariantStyles = () => {
    if (document.getElementById('SSProductVariantStyles')) return;

    const style = document.createElement('style');
    style.id = 'SSProductVariantStyles';
    style.textContent = `
      .ss-product-hero variant-selects {
        display: block;
        width: 100%;
      }

      .ss-product-hero .product-form__input--pill {
        display: flex;
        flex-wrap: wrap;
        gap: 9px;
        width: 100%;
        min-width: 0;
        max-width: none;
        margin: 0;
        padding: 0;
        border: 0;
      }

      .ss-product-hero .product-form__input--pill .form__label {
        width: 100%;
        margin: 0 0 3px;
        padding: 0;
        color: var(--ss-text, #111);
        font-family: var(--font-body-family), Arial, sans-serif;
        font-size: 13px;
        font-weight: 700;
        line-height: 1.35;
        letter-spacing: 0;
      }

      .ss-product-hero .product-form__input--pill input[type='radio'] {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        margin: -1px !important;
        padding: 0 !important;
        overflow: hidden !important;
        clip: rect(0, 0, 0, 0) !important;
        white-space: nowrap !important;
        border: 0 !important;
      }

      .ss-product-hero .product-form__input--pill input[type='radio'] + label {
        display: inline-flex;
        flex: 0 1 auto;
        align-items: center;
        justify-content: center;
        min-height: 46px;
        margin: 0;
        padding: 11px 17px;
        border: 1px solid #d8d8d8;
        border-radius: 12px;
        background: #fff;
        color: #111;
        font-family: var(--font-body-family), Arial, sans-serif;
        font-size: 14px;
        font-weight: 650;
        line-height: 1.2;
        letter-spacing: 0;
        text-align: center;
        cursor: pointer;
        box-shadow: none;
        transition: border-color .16s ease, background-color .16s ease, color .16s ease, box-shadow .16s ease, transform .16s ease;
      }

      .ss-product-hero .product-form__input--pill input[type='radio'] + label::before {
        display: none !important;
      }

      .ss-product-hero .product-form__input--pill input[type='radio'] + label:hover {
        border-color: #111;
      }

      .ss-product-hero .product-form__input--pill input[type='radio']:checked + label {
        border-color: #111;
        background: #111;
        color: #fff;
        box-shadow: 0 0 0 1px #111;
      }

      .ss-product-hero .product-form__input--pill input[type='radio']:focus-visible + label {
        outline: 2px solid #111;
        outline-offset: 3px;
        box-shadow: none;
      }

      .ss-product-hero .product-form__input--pill input[type='radio'].disabled + label,
      .ss-product-hero .product-form__input--pill input[type='radio']:disabled + label {
        border-color: #e4e4e4;
        background: #f7f7f7;
        color: #999;
        text-decoration: line-through;
        cursor: not-allowed;
        box-shadow: none;
      }

      .ss-product-hero .product-form__input--pill input[type='radio'].disabled:checked + label,
      .ss-product-hero .product-form__input--pill input[type='radio']:disabled:checked + label {
        background: #ededed;
        color: #888;
      }

      @media (max-width: 599px) {
        .ss-product-hero .product-form__input--pill {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 8px;
        }

        .ss-product-hero .product-form__input--pill .form__label {
          grid-column: 1 / -1;
        }

        .ss-product-hero .product-form__input--pill input[type='radio'] + label {
          min-width: 0;
          min-height: 50px;
          padding: 10px 7px;
          font-size: 12.5px;
          white-space: normal;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const installUgcRefinementStyles = () => {
    if (document.getElementById('SSProductUgcRefinementStyles')) return;

    const style = document.createElement('style');
    style.id = 'SSProductUgcRefinementStyles';
    style.textContent = `
      .ss-ugc--stories .ss-product-section-title {
        font-family: var(--font-body-family), Arial, sans-serif !important;
        font-style: normal !important;
        font-weight: 700 !important;
        letter-spacing: -.025em !important;
      }

      @media (max-width: 749px) {
        .ss-ugc--stories {
          margin-top: -36px;
          padding-top: 12px !important;
        }

        .ss-ugc--stories .ss-ugc__head {
          margin-bottom: 14px !important;
        }

        .ss-ugc--stories .ss-product-section-title {
          max-width: 100%;
          overflow: visible;
          white-space: nowrap;
          font-size: clamp(18px, 4.7vw, 21px) !important;
          line-height: 1.15 !important;
          letter-spacing: -.025em !important;
        }

        .ss-ugc--stories .ss-ugc__track {
          gap: 9px !important;
          padding-bottom: 6px !important;
        }

        .ss-ugc--stories .ss-ugc-story {
          flex: 0 0 min(26vw, 116px) !important;
          width: min(26vw, 116px) !important;
          border-radius: 14px !important;
        }

        .ss-ugc--stories .ss-ugc-story__caption {
          left: 8px !important;
          right: 39px !important;
          bottom: 9px !important;
          font-size: 9.5px !important;
          line-height: 1.18 !important;
        }

        .ss-ugc--stories .ss-ugc-story__play {
          right: 8px !important;
          bottom: 8px !important;
          width: 32px !important;
          height: 32px !important;
        }

        .ss-ugc--stories .ss-ugc-story__play svg {
          width: 13px !important;
          height: 13px !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const repairProductInfoCompatibility = (scope = document) => {
    const productInfos = scope.querySelectorAll ? scope.querySelectorAll('.ss-product-hero product-info') : [];

    productInfos.forEach((productInfo) => {
      const quantityForm = productInfo.querySelector('[id^="Quantity-Form-"]');
      if (!quantityForm || !productInfo.querySelector('.quantity__input')) return;

      quantityForm.classList.add('product-form__quantity');

      if (!productInfo.quantityForm) {
        if (typeof productInfo.initQuantityHandlers === 'function') {
          productInfo.initQuantityHandlers();
        } else {
          productInfo.quantityForm = quantityForm;
        }
      }
    });
  };

  const moveTrack = (button) => {
    const shell = button.closest('[data-ss-scroll-shell]');
    const track = shell?.querySelector('[data-ss-scroll-track]');
    if (!track) return;
    const direction = Number(button.dataset.ssScrollDirection || 1);
    const amount = Math.min(track.clientWidth * 0.82, 520);
    track.scrollBy({ left: direction * amount, behavior: 'smooth' });
  };

  installVariantStyles();
  installUgcRefinementStyles();
  repairProductInfoCompatibility();

  document.addEventListener('shopify:section:load', (event) => {
    installVariantStyles();
    installUgcRefinementStyles();
    repairProductInfoCompatibility(event.target);
  });

  document.addEventListener('click', (event) => {
    const scrollButton = event.target.closest('[data-ss-scroll-direction]');
    if (scrollButton) {
      event.preventDefault();
      moveTrack(scrollButton);
    }

    const buyLink = event.target.closest('[data-ss-scroll-to-buy]');
    if (buyLink) {
      const target = document.getElementById('SSProductBuy');
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
})();
